import {
  keyBy,
  mapValues,
  range,
  every,
  snakeCase,
  capitalize,
  union,
  without,
  omit,
  find,
  get,
  reduce,
  map,
  pick
} from 'lodash';
import { createSelector } from 'reselect';
// import reduceReducers from 'reduce-reducers';
import { callGraphQLApi } from 'helpers/api';
import { reduceReducers, createReducer } from 'helpers/redux';
import paginate, { makeSelectors } from 'helpers/redux/paginate';
const paginationSelectors = makeSelectors();
import { withConfirmation } from 'modules/confirmation';
import { appPackageComponentTypes } from 'modules/application/constants';

export const namespace = 'applications';

const CREATE = 'vtn/application/CREATE';
export const CREATE_SUCCESS = 'vtn/application/CREATE_SUCCESS';
export const CREATE_FAILURE = 'vtn/application/CREATE_FAILURE';

const UPDATE = 'vtn/application/UPDATE';
export const UPDATE_SUCCESS = 'vtn/application/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'vtn/application/UPDATE_FAILURE';

const DELETE = 'vtn/application/DELETE';
export const DELETE_SUCCESS = 'vtn/application/DELETE_SUCCESS';
export const DELETE_FAILURE = 'vtn/application/DELETE_FAILURE';

export const FETCH_APPLICATION = 'vtn/application/FETCH_APPLICATION';
export const FETCH_APPLICATION_SUCCESS =
  'vtn/application/FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_FAILURE =
  'vtn/application/FETCH_APPLICATION_FAILURE';

export const FETCH_APPLICATION_OAUTH_SECRET =
  'vtn/application/FETCH_APPLICATION_OAUTH_SECRET';
export const FETCH_APPLICATION_OAUTH_SECRET_SUCCESS =
  'vtn/application/FETCH_APPLICATION_OAUTH_SECRET_SUCCESS';
export const FETCH_APPLICATION_OAUTH_SECRET_FAILURE =
  'vtn/application/FETCH_APPLICATION_OAUTH_SECRET_FAILURE';

export const APPLICATION_ACTION = 'vtn/application/APPLICATION_ACTION';
export const APPLICATION_ACTION_SUCCESS =
  'vtn/application/APPLICATION_ACTION_SUCCESS';
export const APPLICATION_ACTION_FAILURE =
  'vtn/application/APPLICATION_ACTION_FAILURE';

export const LIST = 'vtn/application/LIST';
export const LIST_SUCCESS = 'vtn/application/LIST_SUCCESS';
export const LIST_FAILURE = 'vtn/application/LIST_FAILURE';

const LISTING_INITIAL_APPLICATIONS =
  'vtn/application/LISTING_INITIAL_APPLICATIONS';
const DONE_LISTING_INITIAL_APPLICATIONS =
  'vtn/application/DONE_LISTING_INITIAL_APPLICATIONS';

export const FETCH_APP_PACKAGE_COMPONENT_LIST_BY_TYPE =
  'vtn/application/FETCH_APP_PACKAGE_COMPONENT_LIST_BY_TYPE';

const FETCHING_COMPONENTS_OF_TYPE =
  'vtn/application/FETCHING_COMPONENTS_OF_TYPE';
const DONE_FETCHING_COMPONENTS_OF_TYPE =
  'vtn/application/DONE_FETCHING_COMPONENTS_OF_TYPE';

export const FETCH_COMPONENTS_OF_TYPE =
  'vtn/application/FETCH_COMPONENTS_OF_TYPE';
export const FETCH_COMPONENTS_OF_TYPE_SUCCESS =
  'vtn/application/FETCH_COMPONENTS_OF_TYPE_SUCCESS';
export const FETCH_COMPONENTS_OF_TYPE_FAILURE =
  'vtn/application/FETCH_COMPONENTS_OF_TYPE_FAILURE';

const CREATE_CME = 'vtn/application/CREATE_CME';
export const CREATE_CME_SUCCESS = 'vtn/application/CREATE_CME_SUCCESS';

const UPDATE_CME = 'vtn/application/UPDATE_CME';
export const UPDATE_CME_SUCCESS = 'vtn/application/UPDATE_CME_SUCCESS';
export const UPDATE_CME_FAILURE = 'vtn/application/UPDATE_CME_FAILURE';
export const DELETE_CME_SUCCESS = 'vtn/application/DELETE_CME_SUCCESS';

export const UPDATE_APPLICATION_COMPONENTS_SUCCESS =
  'vtn/application/UPDATE_APPLICATION_COMPONENTS_SUCCESS';

const defaultState = {
  applicationsById: {},
  failedFetchingApplications: [],
  isFetchingInitialApplications: false,
  fetchingOAuthSecretApplication: null,
  failedFetchingOAuthSecretApplication: null,
  fetchingOAuthSecretFailureMessage: '',
  isFetchingComponentsOfType: false,
  isFetchingApplications: false,
  componentsOfType: {}
};

const reducer = reduceReducers(
  paginate({
    types: [LIST, LIST_SUCCESS, LIST_FAILURE],
    invalidateOnTypes: [CREATE_SUCCESS, DELETE_SUCCESS],
    idAttribute: 'id'
  }),
  createReducer(defaultState, {
    // [CREATE](state, action) {
    //   return state;
    // },
    [FETCH_APPLICATION](state, action) {
      const requestSuccessState = {
        ...state
        // todo: loading
      };

      return action.error
        ? // handle requestError ie. offline
          this[FETCH_APPLICATION_FAILURE](state, action)
        : requestSuccessState;
    },

    [FETCH_APPLICATION_SUCCESS](state, action) {
      const { signedIconUrl } = action.payload.data.application;
      let signedUrl = signedIconUrl ? decodeURIComponent(decodeURI(signedIconUrl)) : '';
      signedUrl = signedUrl.replaceAll('&amp;', '&');
      signedUrl = signedUrl.replaceAll('host?', 'host&');
      action.payload.data.application.iconUrl = signedUrl;
      action.payload.data.application.signedIconUrl = signedUrl;
      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [action.meta.id]: action.payload.data.application
        },
        failedFetchingApplications: without(
          state.failedFetchingApplications,
          action.meta.id
        )
      };
    },

    [FETCH_APPLICATION_FAILURE](state, action) {
      return {
        ...state,
        failedFetchingApplications: union(state.failedFetchingApplications, [
          action.meta.id
        ])
      };
    },

    [LISTING_INITIAL_APPLICATIONS](state, action) {
      return {
        ...state,
        isFetchingInitialApplications: true
      };
    },

    [DONE_LISTING_INITIAL_APPLICATIONS](state, action) {
      return {
        ...state,
        isFetchingInitialApplications: false
      };
    },

    [LIST](state, action) {
      return {
        ...state,
        isFetchingApplications: true
      };
    },

    [LIST_SUCCESS](state, action) {
      return {
        ...state,
        isFetchingApplications: false,
        applicationsById: {
          ...state.applicationsById,
          ...keyBy(action.payload.data.results.records, 'id')
        }
      };
    },

    [LIST_FAILURE](state, action) {
      return {
        ...state,
        isFetchingApplications: false
      };
    },

    [UPDATE_SUCCESS](state, action) {
      const application = action.payload.data.updateApplication;
      const { signedIconUrl } = application;
      let signedUrl = signedIconUrl ? decodeURIComponent(decodeURI(signedIconUrl)) : '';
      signedUrl = signedUrl.replaceAll('&amp;', '&');
      signedUrl = signedUrl.replaceAll('host?', 'host&');
      application.signedIconUrl = signedUrl;
      application.iconUrl = signedUrl;
      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [application.id]: {
            ...application,
            contextMenuExtensions: application.contextMenuExtensions
          }
        }
      };
    },

    [UPDATE_FAILURE](state, action) {
      return {
        ...state
      };
    },

    [DELETE_SUCCESS](state, action) {
      const id = action.meta; // application id

      return {
        ...state,
        applicationsById: {
          ...omit(state.applicationsById, id)
        }
      };
    },

    [APPLICATION_ACTION_SUCCESS](state, action) {
      const application = action.payload.data.applicationWorkflow;

      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [application.id]: {
            ...application
          }
        }
      };
    },

    [FETCH_APPLICATION_OAUTH_SECRET](state, action) {
      const requestSuccessState = {
        ...state,
        fetchingOAuthSecretApplication: action.meta.id
      };

      return action.error
        ? // handle requestError ie. offline
          this[FETCH_APPLICATION_FAILURE](state, action)
        : requestSuccessState;
    },

    [FETCH_APPLICATION_OAUTH_SECRET_SUCCESS](state, action) {
      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [action.payload.data.application.id]: {
            ...state.applicationsById[action.payload.data.application.id],
            clientSecret: action.payload.data.application.clientSecret
          }
        },
        failedFetchingOAuthSecretApplication: null,
        fetchingOAuthSecretApplication: null,
        fetchingOAuthSecretFailureMessage: ''
      };
    },

    [FETCH_APPLICATION_OAUTH_SECRET_FAILURE](state, action) {
      const secretError = find(action.payload.errors, {
        path: ['application', 'clientSecret']
      });

      return {
        ...state,
        failedFetchingOAuthSecretApplication: action.meta.id,
        fetchingOAuthSecretApplication: null,
        fetchingOAuthSecretFailureMessage: secretError
          ? secretError.message
          : 'Unable to fetch.'
      };
    },

    [FETCH_COMPONENTS_OF_TYPE](state, action) {
      return action.error
        ? this[FETCH_COMPONENTS_OF_TYPE_FAILURE](state, action) // handle requestError ie. offline
        : { ...state };
    },

    [FETCH_COMPONENTS_OF_TYPE_SUCCESS](state, action) {
      const results = get(action.payload, 'data.results.records');

      return {
        ...state,
        componentsOfType: {
          ...state.componentsOfType,
          [action.meta.componentType]: results
        }
      };
    },

    [FETCH_COMPONENTS_OF_TYPE_FAILURE](state, action) {
      return {
        ...state
      };
    },

    [FETCHING_COMPONENTS_OF_TYPE](state, action) {
      return {
        ...state,
        isFetchingComponentsOfType: true
      };
    },

    [DONE_FETCHING_COMPONENTS_OF_TYPE](state, action) {
      return {
        ...state,
        isFetchingComponentsOfType: false
      };
    },

    [UPDATE_APPLICATION_COMPONENTS_SUCCESS](state, action) {
      if (action.error) {
        return this[UPDATE_FAILURE](state, action);
      }

      const { applicationId } = action.meta;
      const data = get(action.payload, 'data.updateApplicationComponent');

      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [applicationId]: {
            ...state.applicationsById[applicationId],
            components: {
              ...state.applicationsById[applicationId].components,
              ...data
            }
          }
        }
      };
    },

    [CREATE_CME_SUCCESS](state, action) {
      if (action.error) {
        return this[UPDATE_FAILURE](state, action);
      }
      const { applicationId } = action.meta;
      const data = action.payload.data.createContextMenuExtension;
      const cmes = get(
        state.applicationsById,
        [applicationId, 'components', 'contextMenuExtensions'],
        []
      );

      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [applicationId]: {
            ...state.applicationsById[applicationId],
            components: {
              ...state.applicationsById[applicationId].components,
              contextMenuExtensions: [...cmes, data]
            }
          }
        }
      };
    },

    [UPDATE_CME_SUCCESS](state, action) {
      if (action.error) {
        return this[UPDATE_FAILURE](state, action);
      }
      const { id, applicationId } = action.meta;
      const data = action.payload.data.updateContextMenuExtension;
      const cmes = get(
        state.applicationsById,
        [applicationId, 'components', 'contextMenuExtensions'],
        []
      );
      const contextMenuExtensions = [...cmes];

      const idx = contextMenuExtensions.findIndex(cme => cme.id === id);

      if (idx !== -1) {
        contextMenuExtensions[idx] = data;
      }

      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [applicationId]: {
            ...state.applicationsById[applicationId],
            components: {
              ...state.applicationsById[applicationId].components,
              contextMenuExtensions
            }
          }
        }
      };
    },

    [DELETE_CME_SUCCESS](state, action) {
      if (action.error) {
        return this[UPDATE_FAILURE](state, action);
      }
      const { id, applicationId } = action.meta;
      const cmes = get(
        state.applicationsById,
        [applicationId, 'components', 'contextMenuExtensions'],
        []
      );
      const contextMenuExtensions = [...cmes];

      const idx = contextMenuExtensions.findIndex(cme => cme.id === id);

      if (idx !== -1) {
        contextMenuExtensions.splice(idx, 1);
      }

      return {
        ...state,
        applicationsById: {
          ...state.applicationsById,
          [applicationId]: {
            ...state.applicationsById[applicationId],
            components: {
              ...state.applicationsById[applicationId].components,
              contextMenuExtensions
            }
          }
        }
      };
    }
  })
);

export default reducer;

function local(state) {
  return state[namespace];
}

export const createApplication = values => (dispatch, getState) => {
  const query = `
    mutation createApplication($input: CreateApplication!) {
      createApplication(input: $input) {
        id
        name
      }
    }
    `;

  return callGraphQLApi({
    actionTypes: [CREATE, CREATE_SUCCESS, CREATE_FAILURE],
    query,
    variables: {
      input: {
        name: values.name,
        description: values.description,
        url: values.url,
        oauth2RedirectUrls: values.oauth2RedirectUrls,
        key: snakeCase(values.name),
        checkPermissions: false,
        iconUrl: values.iconUrl || ''
      }
    },
    dispatch,
    getState
  });
};

export const fetchApplication = id => (dispatch, getState) => {
  const query = `
  ${applicationFieldsFragment}
  query($id: ID!) {
    application(id: $id) {
      ...applicationFields
    }
  }`;

  return callGraphQLApi({
    actionTypes: [
      FETCH_APPLICATION,
      FETCH_APPLICATION_SUCCESS,
      FETCH_APPLICATION_FAILURE
    ],
    query,
    variables: {
      id
    },
    bailout: state =>
      !!getApplications(state)[id] &&
      !!getApplications(state)[id].contextMenuExtensions, // fixme remove once getApplications is refactored to graphql (valid state actions are currently not being returned)
    dispatch,
    getState
  });
};

export const fetchApplicationOauthSecret = (id, password) => (
  dispatch,
  getState
) => {
  const query = `
  query($id: ID!, $password: String!) {
    application(id: $id) {
      id,
      clientSecret(password: $password)
    }
  }`;

  return callGraphQLApi({
    actionTypes: [
      FETCH_APPLICATION_OAUTH_SECRET,
      FETCH_APPLICATION_OAUTH_SECRET_SUCCESS,
      FETCH_APPLICATION_OAUTH_SECRET_FAILURE
    ],
    query,
    variables: {
      id,
      password
    },
    dispatch,
    getState
  });
};

export const updateApplication = values => (dispatch, getState) => {
  const query = `
    ${applicationFieldsFragment}
    mutation updateApplication($input: UpdateApplication!) {
      updateApplication: updateApplication(input: $input) {
        ...applicationFields
      }
    }`;

  return callGraphQLApi({
    actionTypes: [UPDATE, UPDATE_SUCCESS, UPDATE_FAILURE],
    query,
    variables: {
      input: {
        id: values.id,
        name: values.name,
        description: values.description,
        url: values.url || null,
        oauth2RedirectUrls: values.oauth2RedirectUrls || null,
        iconUrl: values.iconUrl
      }
    },
    dispatch,
    getState
  });
};

export const deleteApplication = ({ id }) => (dispatch, getState) => {
  const query = `
    mutation deleteApplication($id: ID!) {
      deleteApplication(id: $id) {
        id
      }
    }
  `;

  return callGraphQLApi({
    actionTypes: [DELETE, DELETE_SUCCESS, DELETE_FAILURE],
    query,
    variables: { id },
    dispatch,
    getState
  });
};

export const confirmDeleteApplication = withConfirmation(
  deleteApplication,
  ({ name }) => ({
    message: `Are you sure you want to delete the application "${name}"?
        You won't be able to undo this action`,
    confirmButtonLabel: 'Delete',
    cancelButtonLabel: 'Cancel'
  })
);

export const listApplications = (
  { offset = 0, limit = 10 } = {},
  { force } = {}
) => (dispatch, getState) => {
  const query = `
    ${applicationFieldsFragment}
    query($limit: Int, $offset: Int) {
      totalResults: applications(owned: true, offset: 0, limit: 9999) {
        count
      }
      results: applications(limit: $limit, offset: $offset, owned: true) {
        records {
          ...applicationFields
        }
      }
    }
  `;

  return callGraphQLApi({
    actionTypes: [LIST, LIST_SUCCESS, LIST_FAILURE],
    query,
    variables: { limit, offset },
    bailout: state => {
      if (force) {
        return false;
      }

      const applications = getPagedApplications(state);
      const needStart = offset;
      const needEnd = offset + limit - 1;

      // bail if all needed applications exist
      return every(range(needStart, needEnd + 1), index => {
        return !!applications[index];
      });
    },
    dispatch,
    getState
  });
};

export const validActions = [
  'edit',
  'enable',
  'delete',
  'deploy',
  'disable',
  'submit',
  'approve',
  'reject'
];

export const doApplicationAction = (action, { id }) => (dispatch, getState) => {
  const query = `
  ${applicationFieldsFragment}
  mutation applicationWorkflow($input: ApplicationWorkflow!) {
    applicationWorkflow: applicationWorkflow(input: $input) {
      ...applicationFields
    }
  }`;

  return callGraphQLApi({
    actionTypes: [
      APPLICATION_ACTION,
      APPLICATION_ACTION_SUCCESS,
      APPLICATION_ACTION_FAILURE
    ],
    query,
    variables: {
      input: {
        id,
        action
      }
    },
    dispatch,
    getState
  });
};

export const fetchComponentsOfType = (
  { componentType, offset = 0, limit = 30 } = {}
) => (dispatch, getState) => {
  const appPackageComponentType = appPackageComponentTypes.find(
    component => component.type === componentType
  );

  if (!appPackageComponentType) return;

  const { group: model } = appPackageComponentType;
  let additionalArgs = '';

  switch (model) {
    case 'engines':
      additionalArgs = 'owned: true';
      break;
    case 'dataRegistries':
      additionalArgs = 'filterByOwnership: mine';
      break;
    default:
      break;
  }

  const query = `
  query($limit: Int, $offset: Int) {
    results: ${model}(limit: $limit, offset: $offset${additionalArgs
    ? `, ${additionalArgs}`
    : ''}) {
      records {
        id
        name
      }
    }
  }`;

  return callGraphQLApi({
    actionTypes: [
      FETCH_COMPONENTS_OF_TYPE,
      FETCH_COMPONENTS_OF_TYPE_SUCCESS,
      FETCH_COMPONENTS_OF_TYPE_FAILURE
    ],
    query,
    variables: { offset, limit },
    meta: { componentType },
    bailout: state => !!getFetchedComponentsOfType(state, componentType).length,
    dispatch,
    getState
  });
};

export const updateApplicationField = (applicationId, field, values) => (
  dispatch,
  getState
) => {
  const query = `
    ${applicationFieldsFragment}
    mutation UpdateApplication($input: UpdateApplication!) {
      updateApplication: updateApplication(input: $input) {
        ...applicationFields
      }
    }`;

  return callGraphQLApi({
    actionTypes: [UPDATE, UPDATE_SUCCESS, UPDATE_FAILURE],
    query,
    variables: {
      input: {
        id: applicationId,
        [field]: values
      }
    },
    dispatch,
    getState
  });
};

export const updateAppPackageComponents = (
  applicationId,
  componentType,
  values
) => (dispatch, getState) => {
  const appPackageComponentType = appPackageComponentTypes.find(
    component => component.type === componentType
  );

  if (!appPackageComponentType) return;

  const query = `
    ${appPackageComponentFieldsFragment}
    mutation UpdateApplicationComponent($input: UpdateApplicationComponent!) {
      updateApplicationComponent: updateApplicationComponent(input: $input) {
        ...appPackageComponentFields
      }
    }`;

  const input = {
    id: applicationId,
    componentIds: values.ids,
    type: appPackageComponentType.group,
    action: values.action
  };

  return callGraphQLApi({
    actionTypes: [
      UPDATE,
      UPDATE_APPLICATION_COMPONENTS_SUCCESS,
      UPDATE_FAILURE
    ],
    query,
    meta: { applicationId },
    variables: { input },
    dispatch,
    getState
  });
};

export const createContextMenuExtension = (applicationId, cme) => (
  dispatch,
  getState
) => {
  const query = `
    ${cmeFieldsFragment}
    mutation CreateContextMenuExtension($input: CreateContextMenuExtension!) {
      createContextMenuExtension: createContextMenuExtension(input: $input) {
        ...cmeFields
      }
    }`;

  const input = pick(cme, ['label', 'url', 'type']);
  input.id = applicationId;

  return callGraphQLApi({
    actionTypes: [CREATE_CME, CREATE_CME_SUCCESS, UPDATE_FAILURE],
    meta: { applicationId },
    query,
    variables: { input },
    dispatch,
    getState
  });
};

export const updateContextMenuExtension = (applicationId, cme) => (
  dispatch,
  getState
) => {
  const query = `
    ${cmeFieldsFragment}
    mutation UpdateAppContextMenuExtension($input: UpdateContextMenuExtension!) {
      updateContextMenuExtension: updateContextMenuExtension(input: $input) {
        ...cmeFields
      }
    }`;

  return callGraphQLApi({
    actionTypes: [UPDATE_CME, UPDATE_CME_SUCCESS, UPDATE_FAILURE],
    meta: { id: cme.id, applicationId },
    query,
    variables: {
      input: pick(cme, ['id', 'label', 'url'])
    },
    dispatch,
    getState
  });
};

export const deleteContextMenuExtension = (applicationId, cme) => (
  dispatch,
  getState
) => {
  const query = `
    mutation DeleteContextMenuExtension($input: DeleteContextMenuExtension!) {
      deleteContextMenuExtension: deleteContextMenuExtension(input: $input) {
        id
      }
    }`;

  return callGraphQLApi({
    actionTypes: [UPDATE, DELETE_CME_SUCCESS, UPDATE_FAILURE],
    meta: { id: cme.id, applicationId },
    query,
    variables: {
      input: { id: cme.id }
    },
    dispatch,
    getState
  });
};

export const confirmDoApplicationAction = withConfirmation(
  doApplicationAction,
  (type, { name }) => ({
    message: `Are you sure you want to ${type} the application "${name}"?`,
    confirmButtonLabel: capitalize(type),
    cancelButtonLabel: 'Cancel'
  })
);

const cmeFieldsFragment = `
fragment cmeFields on ContextMenuExtension {
  id
  label
  url
  type
}`;

const appPackageComponentFieldsFragment = `
${cmeFieldsFragment}
fragment appPackageComponentFields on ApplicationComponent {
  engines {
    records {
      id
      name
      description
      state
      displayName
      deployedVersion
      iconPath
      signedIconPath
    }
  }
  dataRegistries {
    records {
      id
      name
      description
      publishedSchema {
        majorVersion
        minorVersion
        status
      }
    }
  }
  contextMenuExtensions {
    ...cmeFields
  }
}`;

const applicationFieldsFragment = `
${appPackageComponentFieldsFragment}
fragment applicationFields on Application {
  signedIconUrl
  id
  name
  description
  status
  url
  oauth2RedirectUrls
  iconSvg
  iconUrl
  key
  clientSecret
  validStateActions
  createdDateTime
  modifiedDateTime
  components {
    ...appPackageComponentFields
  }
}`;

export function listingInitialApplications() {
  // todo: move to applications overview plugin
  return {
    type: LISTING_INITIAL_APPLICATIONS
  };
}

export function doneListingInitialApplications() {
  return {
    type: DONE_LISTING_INITIAL_APPLICATIONS
  };
}

export function fetchingComponentsOfType() {
  return {
    type: FETCHING_COMPONENTS_OF_TYPE
  };
}

export function donefetchingComponentsOfType() {
  return {
    type: DONE_FETCHING_COMPONENTS_OF_TYPE
  };
}

export function fetchAppPackageComponentsByType(componentType) {
  return {
    type: FETCH_APP_PACKAGE_COMPONENT_LIST_BY_TYPE,
    payload: {
      componentType
    }
  };
}

export const getPagedApplications = createSelector(
  state => paginationSelectors.selectPaginationOrder(local(state)),
  state => local(state).applicationsById,
  (applicationOrder, applicationsById) =>
    mapValues(applicationOrder, (id) => {
      const applicationByIdObject = JSON.parse(JSON.stringify(applicationsById[id]));
      const { signedIconUrl } = applicationByIdObject;
      let signedUrl = signedIconUrl ? decodeURIComponent(decodeURI(signedIconUrl)) : '';
      signedUrl = signedUrl.replaceAll('&amp;', '&');
      signedUrl = signedUrl.replaceAll('host?', 'host&');
      applicationByIdObject.signedIconUrl = signedUrl;
      applicationByIdObject.iconUrl = signedUrl;
      return applicationByIdObject;
    })
);

export function getApplications(state) {
  return local(state).applicationsById;
}

export function getListApplicationsStatus(state) {
  return paginationSelectors.selectFetchingStatus(local(state));
}

export function getLoadingApplications(state) {
  return paginationSelectors.selectFetchingEntities(local(state));
}

export function getFailedLoadingApplications(state) {
  return paginationSelectors.selectFailedFetchingEntities(local(state));
}

export function getFailedFetchingApplications(state) {
  // failure for individually-fetched (by id) applications
  return local(state).failedFetchingApplications;
}

export function getTotalApplications(state) {
  return paginationSelectors.selectTotalEntities(local(state));
}

export function isFetchingInitialApplications(state) {
  return local(state).isFetchingInitialApplications;
}

export function getLoadingOAuthSecretApplication(state) {
  return local(state).fetchingOAuthSecretApplication;
}

export function getFailedLoadingOAuthSecretApplication(state) {
  return local(state).failedFetchingOAuthSecretApplication;
}

export function getFailedLoadingOAuthSecretMessage(state) {
  return local(state).fetchingOAuthSecretFailureMessage;
}

export function isFetchingComponentsOfType(state) {
  return local(state).isFetchingComponentsOfType;
}

export function getFetchedComponentsOfType(state, componentType) {
  return get(local(state), ['componentsOfType', componentType], []);
}

export function isFetchingApplications(state) {
  return local(state).isFetchingApplications;
}

export function getExistingComponentsOfType(
  state,
  applicationId,
  componentType
) {
  const foundComponentType = appPackageComponentTypes.find(
    c => c.type === componentType
  );

  if (!foundComponentType) return {};

  const components = get(
    local(state).applicationsById,
    [applicationId, 'components', foundComponentType.group, 'records'],
    []
  );

  return reduce(
    components,
    (payload, component) => {
      payload[component.id] = component.name;
      return payload;
    },
    {}
  );
}

export function getAppPackageComponentsList(state, applicationId) {
  const application = get(local(state).applicationsById, applicationId, {});

  return reduce(
    map(appPackageComponentTypes, 'group'),
    (payload, group) => {
      payload[group] = getComponentList(application, group);
      return payload;
    },
    {}
  );
}

function getComponentList(application, componentListGroup) {
  switch (componentListGroup) {
    case 'engines':
    case 'dataRegistries':
      return get(
        application,
        ['components', componentListGroup, 'records'],
        []
      );
    case 'contextMenuExtensions':
      return get(application, ['components', componentListGroup]);
    case 'oauth2RedirectUrls':
      return map(application.oauth2RedirectUrls, authUrl => ({
        label: 'OAuth URL',
        url: authUrl
      }));
    case 'appSwitcherShortcuts':
      return application.url
        ? [{ label: 'App Switcher Shortcut', url: application.url }]
        : [];
    default:
      return [];
  }
}

export function getApplicationClientSecret(state, applicationId) {
  return get(
    local(state).applicationsById,
    [applicationId, 'clientSecret'],
    ''
  );
}



// WEBPACK FOOTER //
// ./src/client/modules/application/index.js